import React from 'react'

const SortIcon = () => {
    return (
        <svg className='sort-icon' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.58 86.82">

            <path d="M53.66,33.84c-2.67,2.67-6.99,2.67-9.66,0l-9.34-9.34v55.49c0,3.77-3.05,6.83-6.83,6.83s-6.83-3.06-6.83-6.83V24.5l-9.34,9.34c-2.67,2.67-6.99,2.67-9.66,0-2.67-2.67-2.67-6.99,0-9.66L25.03,1.15c.97-.97,2.34-1.33,3.59-1.06.23.05.45.11.66.2.51.19.98.49,1.39.89l22.99,23c2.67,2.67,2.67,6.99,0,9.66Z" />
            <path d="M104.58,52.98c-2.67-2.67-6.99-2.67-9.66,0l-9.34,9.34V6.83c0-3.77-3.05-6.83-6.83-6.83s-6.83,3.06-6.83,6.83v55.49l-9.34-9.34c-2.67-2.67-6.99-2.67-9.66,0-2.67,2.67-2.67,6.99,0,9.66l23.03,23.03c.97.97,2.34,1.33,3.59,1.06.23-.05.45-.11.66-.2.51-.19.98-.49,1.39-.89l22.99-23c2.67-2.67,2.67-6.99,0-9.66Z" />
        </svg>
    )
}

export default SortIcon
